import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import { Image } from '../../../../atoms';
import { ImageDimensionsType } from '../../../../atoms/Image/Image';

export type Props = {
  className?: string;
  imageDimensions: ImageDimensionsType;
  imageUrl: string;
  isEnterAnimation: boolean;
  isSlideAnimationEnabled: boolean;
  onExitAnimationEnd: () => void;
  statusName: string;
};

const useStyles = makeStyles(() => ({
  noSlide: {
    left: 0,
  },

  root: {
    margin: 'auto',
    position: 'absolute',
    right: 0,
    width: 'max-content',
  },

  slideIn: {
    animation: '$slideIn 1200ms forwards',
    animationTimingFunction: 'cubic-bezier(0.64, 0, 0, 1)',
  },

  '@keyframes slideIn': {
    '0%': { left: '100%' },
    '100%': { left: '0%' },
  },

  slideOut: {
    animation: '$slideOut 1200ms forwards',
    animationTimingFunction: 'cubic-bezier(0.64, 0, 0, 1)',
  },

  '@keyframes slideOut': {
    '0%': { left: '0%' },
    '100%': { left: '-200%' },
  },
}));

export function SlidingImage(props: Props): JSX.Element {
  const {
    className,
    imageDimensions,
    imageUrl,
    isEnterAnimation,
    isSlideAnimationEnabled,
    onExitAnimationEnd,
    statusName,
  } = props;
  const classes = useStyles();

  const rootStyles = clsx(
    'fd-sliding-image',
    classes.root,
    isSlideAnimationEnabled &&
      (isEnterAnimation ? classes.slideIn : classes.slideOut),
    !isSlideAnimationEnabled && classes.noSlide,
  );

  return (
    <div
      data-fd="sliding-image"
      className={rootStyles}
      onAnimationEnd={(): void => !isEnterAnimation && onExitAnimationEnd()}
    >
      <Image
        alt={statusName}
        className={className}
        dimensions={imageDimensions}
        src={imageUrl}
      />
    </div>
  );
}
